import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const SearchBar = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    navigate(`/search?query=${encodeURIComponent(searchTerm)}`);
  };

  return (
    <div id="search-bar-section" className="flex justify-center my-6">
      <form onSubmit={handleSearch} className="flex">
        <input
          id="searchInput" // Asignamos un ID
          type="text"
          placeholder="Buscar productos..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="p-3 border rounded-l-lg w-64 focus:outline-none focus:ring-2 focus:ring-blue-500"
          required
        />
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 rounded-r-lg font-semibold hover:bg-blue-700"
        >
          🔍
        </button>
      </form>
    </div>
  );
};

export default SearchBar;
